import axios, { AxiosResponse } from "axios";
import { camelizeKeys } from "humps";
import queryString from 'query-string';
import Config from '../config';
import { AuthorizationCodeResponse, LocalStorageKeys } from '../types/types';
import Store from '../utils/store';

export async function fetchOauthTokens(code: string) {
  try {
    const response = await getOauthTokens(code);

    Store.setItem(LocalStorageKeys.IdToken, response.idToken);
    Store.setItem(LocalStorageKeys.RefreshToken, response.refreshToken);
  } catch (err) {
    console.error("Error::", err);

    Store.removeItem(LocalStorageKeys.IdToken);
    Store.removeItem(LocalStorageKeys.RefreshToken);
  }
}

export function isAuthenticated(): boolean {
  return !!Store.getItem(LocalStorageKeys.IdToken);
}

export function getIdToken() {
  return Store.getItem(LocalStorageKeys.IdToken);
}

async function getOauthTokens(code: string): Promise<AuthorizationCodeResponse> {
  const response: AxiosResponse<object> = await axios.post(
    `${Config.cognito.url}/oauth2/token`,
    queryString.stringify({
      grant_type: 'authorization_code',
      client_id: Config.cognito.clientId,
      redirect_uri: `${Config.baseUrl}/investors/oauth-sign-in/`,
      code: code
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  );
  return camelizeKeys(response.data) as AuthorizationCodeResponse;
}

